    /* HB Version 1.
*  Updates: Modules are configured from the
* */

import Vue from 'vue/dist/vue.js'
import be from './boot-entities'
import {ajaxManagerConfig} from './configs'
import {getLS} from 'devegram-javascript-util'
const mod2 = {
    "voip-customer-rate":null,
      "voip-customer":null,
}
const mods = {
    "voip-report-analysis-statistic":null,
      "form_sign_up_fas_free_routes":null,
      "voip-report":null,
      "network-server":null,
      "voip-vos-server":null,
      "voip-fusion-server":null,
      "voip-test-automation-no-actions":null,
      "voip-assign-destinations-for-users":null,
      "voip-test-automation":null,
      "voip-sip-dialer":null,
      "voip-customer-target-list":null,
      "voip-fusion-billing":null,
      "voip-fusion-billing-payment":null,
      "user-generate-live-features":null,
      "user-customer-features":null,
      "testing-history-page":null,
      "voip-reseller-rate":null,
      "voip-reseller":null,
      "user":null,
      "user-reseller-features":null,
      "user-side-menu":null,
      "voip-customer-rate":null,
      "voip-customer":null,
      "voip-vos-cdr-viewer":null,
      "voip-vendor-destination-status-menu":null,
      "voip-vendor-destination-status":null,
      "voip-rtp-finder":null,
      "voip_user_division_profit_percents":null,
      "voip-vendor-side-menu":null,
      "voip-vendor":null,
      "voip-testing-numbers-side-menu":null,
      "voip-testing-numbers":null,
      "voip-destination":null,
      "voip-destination-side-menu":null,
      "voip-dialplan":null,
      "voip-generate-live-user-active-calls":null,
      "voip-rate-division-side-menu":null,
      "voip-rate-division":null,
      "voip-lcr-menu":null,
      "voip-testing-panel":null,
      "voip-testing-panel-default-setting":null,
      "voip-testing-panel-setting":null,
      "voip-testing-panel-user-setting":null,
      "voip-lcr-top-destinations":null,
      "voip-lcr-report":null
}
const boot = (app) => {
    return new Promise(async (resolve) => {
        let router = bootGlobalData(app)
        await bootConfigs(app)
        await bootDefaultVuexModules()
        await bootUserPermissions()
        await loadRouterRoutes()
        await $store.dispatch('app-state/doneLoading')
        // await loadV2ExtneralComponent('tmtm2', 'https://backend.fasfreeroute.com/xapi/Voip/CallTestStatus/comp')
        resolve({
            router
        })
    })
}

const bootGlobalData = (app) => {
    const globalData = {}
    let {router} = be.bindStoreAndRouter(globalData)
    be.bindWLogger(globalData)
    be.bootUILangSetting(globalData)
    be.bindXModules(globalData)
    be.bindGlobalData(app, globalData)
    return router;
}

const bootConfigs = async (app) => {
    await ajaxManagerConfig()
}

const bootDefaultVuexModules = async () => {
    return new Promise(async function (resolve) {
        $xmodule.load('user').then(async function () {
            await $xmodule.load('app')
            await $xmodule.load('side-nav')
            //  await $xmodule.load('voip-customer-target-list')
            await bootModules($store.state['user-state'].modules)
            resolve()
        })
    })
}


export const bootModules = async (modules) => {
    return new Promise(async function (resolve) {
        let promises = []
        let keys = Object.keys(modules)
        keys.forEach((moduleName) => {
            promises.push($xmodule.load(moduleName))
        })
        let result = await Promise.all(promises)
        resolve()
    })
}

const bootUserPermissions = () => {
    return new Promise((resolve, reject) => {
        if (getLS('user')) {
            $store.dispatch('user-api/verify', {
                onError: (error, resolve, reject) => {
                    resolve(false)
                }
            }).then((r) => {
                // debugger
                // bootModules(mod2).then(() => {
                //     resolve(true)
                // })
                // let data = r.data.modules;
                // debugger;
                bootModules(r.data.modules).then(() => {
                    resolve(true)
                })
            }).catch( error  => {
                resolve(false)
            })
        } else {
            resolve(false)
        }
    })
}

export const loadV2ExtneralComponent =  (compName, compJSONUrl) => {
    /*$store.dispatch('ajaxManager/api', api, { root: true }).then(r => {
        //console.log('compJSONUrl', r.data)
        console.log('compJSONUrl', 1, JSON.parse(r.data))
    }).catch(e => {

    });*/

    return new Promise(async function (resolve) {
        fetch(compJSONUrl).then( res => res.json()).then( r => {
            let compObj = {}
            compObj.template = r
            compObj.data = () => {
                return {
                    message: 'Hello Hassan'
                }
            }

            $vue.component(compName, compObj)
            resolve(1)
        })
    })

    // compJSONUrl e.g myComponent.json



    // e.g
    /* JSON
        {
            "template": "<div><span>{{message}}</span></div>",
            "data": function() {
                return { "message": "Hello World" };
            }
        }
    */
}

const loadRouterRoutes = function () {
    return new Promise(async function (resolve, reject) {
        let l = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '')
        let current = location.toString().replace(l, '')
        /*let currentPortal = current.split('/')[1]
        if (currentPortal.length === 0) {
          currentPortal = 'home'
          router.push('home')
        }
        let {default: portalRoutes} = await import('@/app/portals/' + currentPortal + '/routes.js')
        router.addRoutes(portalRoutes)
        */
        resolve()
    })
}

export default boot
